import React, { memo, useEffect } from "react"
import Toast from "./Toast"
import Snackbar from "./Snackbar"
import useSnackbarStore from "../../stores/snackbar"

const SnackbarProvider = () => {
  const toggleSnackbar = useSnackbarStore((state) => state.toggleSnackbar)
  const isSnackbarActive = useSnackbarStore((state) => state.snackbar?.isActive)
  const snackbarText = useSnackbarStore((state) => state.snackbar?.text)
  const snackbarColor = useSnackbarStore((state) => state.snackbar?.color)
  const snackbarDuration = useSnackbarStore(
    (state) => state.snackbar?.durationMs,
  )

  const toggleToast = useSnackbarStore((state) => state.toggleToast)
  const isToastActive = useSnackbarStore((state) => state.toast?.isActive)
  const toastText = useSnackbarStore((state) => state.toast?.text)
  const toastColor = useSnackbarStore((state) => state.toast?.color)
  const toastDuration = useSnackbarStore((state) => state.toast?.durationMs)

  useEffect(() => {
    if (!isSnackbarActive) {
      return
    }

    const timer = setTimeout(() => {
      toggleSnackbar({
        isActive: false,
      })
    }, snackbarDuration ?? (snackbarColor === "loading" ? 5000 : 3000))

    return () => clearTimeout(timer)
  }, [
    isSnackbarActive,
    snackbarColor,
    snackbarDuration,
    snackbarText,
    toggleSnackbar,
  ])

  useEffect(() => {
    if (!isToastActive) {
      return
    }

    const timer = setTimeout(() => {
      toggleToast({
        isActive: false,
      })
    }, toastDuration ?? (toastColor === "loading" ? 5000 : 3000))

    return () => clearTimeout(timer)
  }, [
    isToastActive,
    toastColor,
    toastDuration,
    toastText,
    toggleSnackbar,
    toggleToast,
  ])

  return (
    <>
      <Toast active={isToastActive} text={toastText} color={toastColor} />
      <Snackbar
        active={isSnackbarActive}
        text={snackbarText}
        color={snackbarColor}
      />
    </>
  )
}

export default memo(SnackbarProvider)
